import BaseRepository from "./BaseRepository";
import PhaseModel from "../models/phase";

export default class PhaseRepository extends BaseRepository {
    async get(projectId) {
        let uri = `/phases/by-project/${projectId}`;

        let response = await this._requestWithTimeoutAsync('GET', uri);

        if (response === undefined) {
            return [];
        }

        console.log('Status: ', response.status);

        let json = await response.json();
        let phases = this.__mapJsonToPhaseModels(json);

        console.log('Phases: ', phases);

        return phases;
    }

    async delete(phaseId) {
        let uri = `/phases/${phaseId}`;

        try {
            let response = await this._requestWithTimeoutAsync('DELETE', uri);

            if (!response.ok) {
                return false;
            }
        }
        catch (error) {
            return false;
        }

        return true;
    }

    __mapJsonToPhaseModels(json) {
        let phase = [];

        json.forEach((raw) => {
            phase.push(new PhaseModel(raw.id, raw.name, raw.short_name, raw.project_id));
        });

        return phase;
    }
}


// WEBPACK FOOTER //
// ./src/data/PhaseRepository.js